const getURLParams = function () {
    return serializeParams(window.location.search);
};

const serializeParams = function (searchString) {
    let params = {};
    const keypairs = searchString.replace("?", "").split("&");
    keypairs.forEach((kp) => {
        const kp_array = kp.split("=");
        params[kp_array[0]] = kp_array[1];
    });
    return params;
};

export default getURLParams;
